import { render, staticRenderFns } from "./SelectSubscriptionPage.vue?vue&type=template&id=18a1c732&scoped=true&"
import script from "./SelectSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./SelectSubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSubscriptionPage.vue?vue&type=style&index=0&id=18a1c732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1c732",
  null
  
)

export default component.exports